module.exports = "/_next/static/images/newsBg-10a7001afc4e3b2e0a5a588a22ccaa3f.webp";